module.exports = __webpack_public_path__ + "img/kehuishouwu_bg.215ef4ce.png";